import { getAttribution } from './attribution';

const OFFICIAL_HOSTNAME = 'eientech.io';
const BLOCKED_PARAM_KEYS = new Set([
  'name',
  'email',
  'phone',
  'message',
  'nombre',
  'mensaje',
  'telefono',
  'tel',
]);

const hasWindow = () => typeof window !== 'undefined';

export const isProductionAnalyticsEnabled = () => {
  if (!hasWindow()) return false;
  return (
    window.location.hostname === OFFICIAL_HOSTNAME &&
    window.__eienGa4Enabled === true &&
    typeof window.gtag === 'function'
  );
};

const getPagePath = () => {
  if (!hasWindow()) return '/';
  return `${window.location.pathname}${window.location.hash || ''}`;
};

const sanitizePayload = (params = {}) =>
  Object.entries(params).reduce((acc, [key, value]) => {
    if (BLOCKED_PARAM_KEYS.has(key)) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(`[analytics] blocked potential PII param: ${key}`);
      }
      return acc;
    }

    if (value === undefined || value === null || value === '') return acc;
    acc[key] = typeof value === 'string' ? value.slice(0, 100) : value;
    return acc;
  }, {});

export const trackEvent = (eventName, params = {}) => {
  if (!hasWindow()) return;

  const payload = sanitizePayload({
    page_path: getPagePath(),
    ...getAttribution(),
    ...params,
  });

  window.__eienAnalyticsEvents = window.__eienAnalyticsEvents || [];
  window.__eienAnalyticsEvents.push({ event: eventName, params: payload });

  if (!isProductionAnalyticsEnabled()) return;
  window.gtag('event', eventName, payload);
};
